import { memo, useMemo } from 'react';
import Image from 'next/image';

import ChevronRight from '~/public/font-awesome/chevron-right-bolt.png';

export type FTFPostsPaginationProps = {
  from: number;
  to: number;
  length: number;
  disablePrev: boolean;
  disableNext: boolean;
  onClick: (factor: number) => void;
};

export default memo(function FTFPostsPagination({
  from,
  to,
  length,
  disablePrev,
  disableNext,
  onClick,
}: Readonly<FTFPostsPaginationProps>) {
  const message = useMemo(
    () => `Showing messages ${from}-${to} of ${length}`,
    [from, to, length],
  );

  return (
    <div className="flex items-center justify-center gap-4 md:justify-start">
      <button
        onClick={() => onClick(-1)}
        disabled={disablePrev}
        className="disabled:opacity-50"
        data-testid="ftf-posts-pagination-prev-btn"
      >
        <Image
          src={ChevronRight}
          alt="Go to previous page"
          width={16}
          height={16}
          className="inline-block h-4 w-4 rotate-180"
        />
      </button>
      <span className="font-medium">{message}</span>
      <button
        onClick={() => onClick(1)}
        disabled={disableNext}
        className="disabled:opacity-50"
        data-testid="ftf-posts-pagination-next-btn"
      >
        <Image
          src={ChevronRight}
          alt="Go to next page"
          width={16}
          height={16}
          className="inline-block h-4 w-4"
        />
      </button>
    </div>
  );
});
